import { useQuery } from "@apollo/client";
import { ConditionalType } from "@regal-voice/shared-types";

import { getEventType } from "Pages/orchestration/Pages/journeys/JourneyEditPage/Components/JourneyBuilder/shared/helpers";
import { getEventFields, type EventSchemaListReturnType } from "ServerData/EventSchema/queries";

import type { EventSchema } from "Types/ContactAttribute";
import type { NodeTriggerType } from "Types/Journey";

const emptyAttributes: Array<EventSchema> = [];

type HookProps = {
    eventType?: NodeTriggerType | ConditionalType;
    eventName?: string;
};

export function useEventsAttributesFullListQuery({ eventType, eventName }: HookProps): {
    loading: boolean;
    eventAttributes: Record<string, string>[];
} {
    const shouldSkip = !eventType || !eventName;
    const typeForEvent = getEventType(eventType as NodeTriggerType);
    const { loading, data } = useQuery<EventSchemaListReturnType>(getEventFields, {
        notifyOnNetworkStatusChange: true,
        fetchPolicy: "no-cache",
        skip: shouldSkip,
        variables: {
            eventType: typeForEvent,
            eventName: eventName,
        },
    });

    const eventAttributes = data?.getEventSchema || emptyAttributes;

    return { loading, eventAttributes };
}
